import { GraphMutationBuilderPayload, createMutation } from '@camelot/server';

import {
  MailSyncConfigurationCreationPayload,
  MailSyncConfigurationModifierPayload,
} from './dto/mail-sync-configuration';
import { CommunicationPayloadInput, StartOutboundConversationPayloadInput } from './dto/post/communication';
import { CreateTemplatePayloadInput, UpdateTemplatePayloadInput } from './dto/post/template';
import { CreateTemplateVariantPayloadInput, UpdateTemplateVariantPayloadInput } from './dto/post/template-variation';
import { CreateUserSignaturePayloadInput, UpdateUserSignaturePayloadInput } from './dto/signature';

export function CREATE_CONVERSATION(com: CommunicationPayloadInput): GraphMutationBuilderPayload {
  return createMutation('createNewCommunication', {
    argument: 'communicationPayload',
    type: 'CommunicationPayloadInput',
    value: com,
  });
}

export function START_OUTBOUND_CONVERSATION(
  payload: StartOutboundConversationPayloadInput
): GraphMutationBuilderPayload {
  return createMutation('startOutboundConversation', {
    value: payload,
  });
}

export function CREATE_TEMPLATE(template: CreateTemplatePayloadInput): GraphMutationBuilderPayload {
  return createMutation('createTemplate', {
    argument: 'createTemplatePayload',
    value: template,
  });
}

export function UPDATE_TEMPLATE(template: UpdateTemplatePayloadInput): GraphMutationBuilderPayload {
  return createMutation('updateTemplate', {
    argument: 'updateTemplatePayload',
    value: template,
  });
}

export function CREATE_VARIANT(variant: CreateTemplateVariantPayloadInput): GraphMutationBuilderPayload {
  return createMutation('createTemplateVariant', {
    argument: 'createTemplateVariantPayload',
    value: variant,
  });
}

export function UPDATE_VARIANT(variant: UpdateTemplateVariantPayloadInput): GraphMutationBuilderPayload {
  return createMutation('updateTemplateVariant', {
    argument: 'updateTemplateVariantPayload',
    value: variant,
  });
}

export function CREATE_MY_SIGNATURE(payload: CreateUserSignaturePayloadInput): GraphMutationBuilderPayload {
  return createMutation('createUserSignature', {
    value: payload,
  });
}

export function UPDATE_MY_SIGNATURE(payload: Partial<UpdateUserSignaturePayloadInput>): GraphMutationBuilderPayload {
  return createMutation('updateUserSignature', {
    value: payload,
  });
}

export function CREATE_MAIL_SYNC_CONFIG(payload: MailSyncConfigurationCreationPayload): GraphMutationBuilderPayload {
  return createMutation('createNewMailSyncConfiguration', {
    argument: 'mailSyncConfigurationPayload',
    type: 'MailSyncConfigurationCreationPayloadInput!',
    value: payload,
  });
}

export function UPDATE_MAIL_SYNC_CONFIG(
  payload: Partial<MailSyncConfigurationModifierPayload>
): GraphMutationBuilderPayload {
  return createMutation('updateMailSyncConfiguration', {
    argument: 'mailSyncConfigurationPayload',
    type: 'MailSyncConfigurationModifierPayloadInput!',
    value: payload,
  });
}
